var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.text !== '')?_c('div',{staticClass:"news-banner"},[_c('div',{staticClass:"news-banner__content"},[_c('span',{staticStyle:{"font-size":"18px"}},[_vm._t("before"),_vm._v(" "+_vm._s(_vm.text)+" "),_vm._t("after")],2)])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }